const fonts={
    default:"font-family: 'Open Sans', sans-serif;",
    text:"font-family: 'Open Sans', sans-serif;",
    headings:"font-family: 'Raleway', sans-serif;"
}

export default fonts;


